module.exports = __webpack_public_path__ + "static/media/animal-guitar.194d1ce3.PNG";